import { render, staticRenderFns } from "./PointeCriteria.vue?vue&type=template&id=c7709a54&scoped=true"
import script from "./PointeCriteria.vue?vue&type=script&lang=js"
export * from "./PointeCriteria.vue?vue&type=script&lang=js"
import style0 from "./PointeCriteria.vue?vue&type=style&index=0&id=c7709a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7709a54",
  null
  
)

export default component.exports